import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

export default function useProject(projectId) {
  const [project, setProject] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [ph, pr, t] = await Promise.all([
        api.get("/phases"),
        api.get(`/projects/${projectId}`),
        api.get(`/projects/${projectId}/tasks`),
      ]);
      setPhases(ph.data);
      setProject(pr.data);
      setTasks(t.data);
    } catch (e) {
      setError(e?.response?.status || 500);
    } finally {
      setLoading(false);
    }
  }, [projectId]);

  useEffect(() => {
    load();
  }, [load]);

  const refreshProject = useCallback(async () => {
    const r = await api.get(`/projects/${projectId}`);
    setProject(r.data);
  }, [projectId]);

  return { project, setProject, tasks, setTasks, phases, loading, error, reload: load, refreshProject };
}
